import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Spinner, Form } from 'react-bootstrap';
import { useNavigate,useSearchParams,useLocation } from 'react-router-dom';
import { FaStop, FaMicrophone } from "react-icons/fa";
import { postDataUser } from '../ApiServices/ApiService'; // Ensure this import path is correct

const UsersDemoQuestions = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const examId = searchParams.get('id');
  // const examType = searchParams.get('exam-type');
  const location =useLocation()
  const examType = location.state?.examType || 'THEORY';
  const [questions, setQuestions] = useState([
    {
      qid: "1",
      q_text: "Demo Question 1: What is Continuous Integration?",
      q_answer: ""
    },
    {
      qid: "2",
      q_text: "Demo Question 2: What is RESTful API?",
      q_answer: ""
    },
  ]);

  const [codingquestions, setCodingQuestions] = useState([
    {
      qid: "1",
      q_text: "Demo Coding Question 1: Write A Program To Print Hello World! In Python",
      q_answer: ""
    },
    {
      qid: "2",
      q_text: "Demo Coding Question 2: Write A Program To Print Hello World! In Java",
      q_answer: ""
    },
  ]);

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [timer, setTimer] = useState(60); // 1 minute for each question
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isGetAns, setIsGetAns] = useState(false); // Adjusted for API call state
  const [isRecording, setIsRecording] = useState(false);
  const [audioChunks, setAudioChunks] = useState([]);
  const [respError, setRespError] = useState('');
  const audioStreamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const mediaVideoRecorderRef = useRef(null);
  const videoRef = useRef(null);
  const chunksRef = useRef([]);
  const testId = "demoTestID"; // Assuming a demo test ID, replace with actual logic as needed

  // const startCapture = () => {
  //   navigator.mediaDevices.getUserMedia({ video: true })
  //     .then((stream) => {
  //       videoRef.current.srcObject = stream;
  //       videoRef.current.onloadedmetadata = () => {
  //         videoRef.current.play();
  //         mediaVideoRecorderRef.current = new MediaRecorder(stream);
  //         const chunks = [];
  //         mediaVideoRecorderRef.current.ondataavailable = (event) => {
  //           if (event.data.size > 0) {
  //             chunks.push(event.data);
  //           }
  //         };
  
  //         mediaVideoRecorderRef.current.onstop = () => {
  //           const blob = new Blob(chunks, { type: 'video/webm' });
  //           console.log("video", blob );
  //         };
  
  //         mediaVideoRecorderRef.current.start();
  //       };
  //     })
  //     .catch((err) => {
  //       console.error('Error accessing the camera:', err);
  //     });
  // };

  // useEffect(() => {
  //   startCapture();
  // }, []);
  
  

  // const stopCapture = () => {
  //   mediaVideoRecorderRef.current.stop();
  
  //   const stream = videoRef.current.srcObject;
  //   const tracks = stream.getTracks();
  
  //   tracks.forEach((track) => {
  //     track.stop();
  //   });
  
  //   videoRef.current.srcObject = null;
  
  //   setTimeout(() => {
  //     console.log('Camera stream stopped');
  //   }, 1000);
  // };

  useEffect(() => {
    // Timer and navigation effects remain unchanged...
  }, [timer, currentQuestionIndex, questions.length]);

  const convertBlobToTexts = async (qId, blobAudio) => {  
    const payload = new FormData();
    payload.append("op", "audio_trans");
    payload.append("test_id", testId);
    payload.append("qid", qId);
    payload.append("audio_data", blobAudio);

    setIsGetAns(true);
    try {
      const respData = await postDataUser('candidate_audio_transcription', payload);
      setIsGetAns(false);
      if (respData && respData.statusCode === 200) {
        setQuestions((prevQuestions) =>
          prevQuestions.map((question) => {
            if (question.qid === qId) {
              return { ...question, q_answer: respData.dataJ.q_answer };
            }
            return question;
          })
        );
      } else {
        throw new Error(respData.info || "Failed to transcribe audio");
      }
    } catch (error) {
      console.error('Error transcribing audio:', error);
      setRespError(error.message || 'Error in audio transcription.');
      setIsGetAns(false);
    }
  };

  const convertBlobToText = async (qId, blobAudio) => {  
    const payload = {
      "op":"audio_trans",
      "test_id": "t_id_2024030808100541078254",
      "qid": qId,
      "audio_data": blobAudio
    }
    console.log("payload",payload);
    setIsGetAns(true)
    postDataUser('candidate_audio_transcription', payload).then(resp => {
      resp.json().then(respData => {        
        setIsGetAns(false)
        if (resp.status === 200) {
          if (respData.statusCode === 200) {
            const questionIndex = questions.findIndex((question) => question.qid === respData.dataJ.qId);

            // If the question is found, update its answer to an empty string
            if (questionIndex !== -1) {
              const updatedQuestions = [...questions];
              updatedQuestions[questionIndex] = {
                ...updatedQuestions[questionIndex],
                q_answer: updatedQuestions[questionIndex].q_answer + ' '+ respData.dataJ.q_answer,// (for concatenate existing and New)
              };
              setQuestions(updatedQuestions);
            }
 
          } else if(respData.statusCode === 500) {
            setError(respData.info);
          }else{
            setError('Network Error');
          }
        } else if (resp.status === 401 || resp.status === 403) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
            //   callRefreshTokenApi('getSfeBatch', '');
          }
        } else {
          console.log('resp status else  : ', resp);
        }
      }).catch((error) => {
        setError('Network Error');
        setIsGetAns(false)
        console.log('network error:', error);
      });
    }).catch((error) => {
      setError('Network Error');
      setIsGetAns(false)
      console.log('network error:', error);
    });
  }

  const transcribeAudio = async (audioBlob) => {
    const formData = new FormData();
    formData.append("audio_data", audioBlob);

    try {
      const response = await fetch('candidate_audio_transcription', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        setRespError('Failed to transcribe audio. Please try again.');
        throw new Error('Network response was not ok');
      }

      const result = await response.json();
      return result; // Adjust according to your actual API response structure
    } catch (error) {
      console.error('Error transcribing audio:', error);
      setRespError(error.message);
    }
  };

  const handleRecordingStarts = async () => {
    setAudioChunks([]);
    try {
      audioStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(audioStreamRef.current);

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) {
          setAudioChunks((prevChunks) => [...prevChunks, e.data]);
        }
      };

      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
        const transcriptionResult = await transcribeAudio(audioBlob);
        if (transcriptionResult && transcriptionResult.transcription) {
          setQuestions((prevQuestions) =>
            prevQuestions.map((question, index) => {
              if (index === currentQuestionIndex) {
                return { ...question, q_answer: transcriptionResult.transcription };
              }
              return question;
            })
          );
        }
        setIsRecording(false);
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
      setRespError('Error accessing microphone.');
    }
  };

  const handleRecordingStart = async () => {
    console.log("handleRecordingStart()............................");
    setAudioChunks([]);
    try {
      audioStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(audioStreamRef.current);

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) {
          const audioBlob = new Blob([e.data], { type: 'audio/wav' });
          // setAudioChunks((prevChunks) => [...prevChunks, e.data]);
          const reader = new FileReader();
          reader.onload = () => {
            console.log("handleRecordingStart onstop() onload()");
            const base64String = reader.result.split(',')[1];
            convertBlobToText(currentQuestion?.qid, base64String);
          };
          reader.readAsDataURL(audioBlob);
          setQuestionChunksList((prevList) => [...prevList, e.data]);

        }
      };

      mediaRecorderRef.current.onstop = () => {
        console.log("handleRecordingStart onstop()");
        // setAudioChunks((prevChunks) => {
        //   console.log("handleRecordingStart onstop() setAudioChunks()");
        //   const audioBlob = new Blob(prevChunks, { type: 'audio/wav' });
        //   const reader = new FileReader();
        //   reader.onload = () => {
        //     console.log("handleRecordingStart onstop() onload()");
        //     const base64String = reader.result.split(',')[1];
        //     convertBlobToText(currentQuestion?.qid, base64String);
        //   };
        //   reader.readAsDataURL(audioBlob);
        //   setQuestionChunksList((prevList) => [...prevList, ...prevChunks]);

        //   return prevChunks; // Return the new state
        // });

      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };

  const handleRecordingStop = async () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      if (audioStreamRef.current) {
        audioStreamRef.current.getTracks().forEach((track) => track.stop());
      }
      setIsRecording(false);
      const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
      const qId = questions[currentQuestionIndex].qid;
      await convertBlobToText(qId, audioBlob);
    } else {
      console.error('mediaRecorderRef.current is null');
    }
  };

  const handleMicClick = () => {
    if (isRecording) {
      handleRecordingStop();
    } else {
      handleRecordingStart();
    }
  };

  const handleNextQuestions = () => {
    if (currentQuestionIndex + 1 < questions.length) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      setTimer(60); 
    } else {
      handleSubmit(); 
    }
  };

  const [isTimerRunning, setIsTimerRunning] = useState(true);
  useEffect(() => {
    let timerId;
    if (isTimerRunning && timer > 0) {
      timerId = setTimeout(() => setTimer(timer - 1), 1000);
    } else if (timer <= 0) {
       handleRecordingStop();
      let totalQuestion = totalQuestions - 2;
      if (currentQuestionIndex > totalQuestion) {
        //End of total test
       
        // handleSubmit();
      } else {
    // nextType ==> LAST,NORMAL,BUTTON
    //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
        // handleNextQuestion("NORMAL","AUTOSUBMIT"); //Automatic Submit and Normal
      }
    } else {
      console.log('not 0');
    }

    return () => clearTimeout(timerId);
  }, [timer, isTimerRunning]);


  const currentQuestion = questions[currentQuestionIndex];
  const [questionChunksList, setQuestionChunksList] = useState([]);
  const [fetchedTestTimeId, setFetchedTestTimeId] = useState(60);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [userCode, setUserCode] = useState(currentQuestion?.q_answer || currentQuestion?.skeleton_code || '');
  useEffect(()=>{
    setUserCode(currentQuestion?.q_answer || currentQuestion?.skeleton_code || '')
  },[currentQuestion] )
  const handleNextQuestion = async (nextType,stopMicType) => {
    // nextType ==> LAST,NORMAL,BUTTON
    //stopMicTypes: MIC,SUBMIT,AUTOSUBMIT
    handleRecordingStop("SUBMIT");    
    console.log('handleNextQuestion  nextType:', nextType," stopMicType:",stopMicType," questionChunksList:" ,questionChunksList);
    const audioBlob = new Blob(questionChunksList, { type: 'audio/wav' });
    const reader = new FileReader();
    reader.onload = () => {
      console.log("handleNextQuestion()");
      const base64String = reader.result.split(',')[1];
      convertBlobToTextFinal(currentQuestion?.qid, base64String);
    };
    reader.readAsDataURL(audioBlob);
    setQuestionChunksList([]);
    setAudioChunks([]);
    console.log('setAudioChunks []', audioChunks);

    // nextType ==> LAST,NORMAL,BUTTON
    if(nextType !== "LAST"){
      setUserCode('');
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      setShowSubmitButton(false);
      setTimer(fetchedTestTimeId);
      // setnextTimer(testTime);
      let totalQuestion = questions.length -2;
      if (currentQuestionIndex >= totalQuestion) {
        setShowSubmitButton(true);
      }
    }


  };

  useEffect(() => {
    if (fetchedTestTimeId !== null) {
      setTimer(fetchedTestTimeId); 
    }
  }, [fetchedTestTimeId]);


  const [error, setError] = useState('');
  const convertBlobToTextFinal = async (qId, blobAudio) => {
    console.log('Service convertBlobToTextFinal qId', qId, 'blobAudio',);    
    const payload = {
      "op":"audio_trans_final",
      "test_id": testId,
      "qid": qId,
      "audio_data": blobAudio
    }
    postDataUser('candidate_audio_transcription', payload).then(resp => {
      resp.json().then(respData => {
        if (resp.status === 200) {
          if (respData.statusCode === 200) {
            const questionIndex = questions.findIndex((question) => question.qid === respData.dataJ.qId);

            // If the question is found, update its answer to an empty string
            if (questionIndex !== -1) {
              const updatedQuestions = [...questions];
              updatedQuestions[questionIndex] = {
                ...updatedQuestions[questionIndex],
                q_answer: respData.dataJ.q_answer,// (for New)
              };
              setQuestions(updatedQuestions);
            }
 
          } else if(respData.statusCode === 500) {
            setError(respData.info);
            console.log('resp else  : ', resp.info);
          }else{
            setError('Network Error');
          }
        } else if (resp.status === 401 || resp.status === 403) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
            //   callRefreshTokenApi('getSfeBatch', '');
          }
        }else {
          console.log('resp status else  : ', resp);
        }
      }).catch((error) => {
        setError('Network Error');
        console.log('network error:', error);
      });
    }).catch((error) => {
      setError('Network Error');
      console.log('network error:', error);
    });
  }

  const handleSubmit = () => {
    // stopCapture();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate(`/users-instructions?id=${examId}&exam-type=${examType}`)
      // window.location.reload();
    }, 2000);
  };

  const handleClearAns = (qId) => {
    // Find the index of the question with the specified qid
    const questionIndex = questions.findIndex((question) => question.qid === qId);

    // If the question is found, update its answer to an empty string
    if (questionIndex !== -1) {
      const updatedQuestions = [...questions];
      updatedQuestions[questionIndex] = {
        ...updatedQuestions[questionIndex],
        q_answer: '',
      };
      setQuestions(updatedQuestions);
    }
    
    setQuestionChunksList([]);

    
  }

  return (
    <div className='user-qus-div' >
      {/* <div style={{display:'flex',justifyContent:'end', alignItems:"end",padding:'10px'}}>
        <video ref={videoRef} width="180" height="150"/>
      </div> */}
      <div className="question-div" style={{padding:'40px 10px'}}>
        <Row className="justify-content-center">
          <Col xs={12} md={12}>
            <div>
              <h2 className="text-center mb-4">Question {questions[currentQuestionIndex]?.qid}</h2>
              {examType === 'THEORY' ? (
                  <p className="text-center">{questions[currentQuestionIndex]?.q_text}</p>
                ) : (
                  <p className="text-center">{codingquestions[currentQuestionIndex]?.q_text}</p>
                )}
              <Row>
              {examType === 'THEORY' ? (
                  <Col xs={10}>
                    <Form.Group>
                      <Form.Control as="textarea" rows={6} value={questions[currentQuestionIndex]?.q_answer} placeholder="Please speak to answer..." />
                    </Form.Group>
                  </Col>
                ) : (
                  <Col xs={12}>
                    <Form.Group>
                      {/* Render another Form.Control for coding questions */}
                      <Form.Control as="textarea" rows={8} value={userCode} onChange={(e) => setUserCode(e.target.value)} disabled={timer === 0} placeholder="Code Your answer..." />
                    </Form.Group>
                  </Col>
                )}
               <Col xs={2}>
               {/* <div className="text-center mt-3">
                <Button variant="outline-danger" onClick={handleMicClick}>
                  {isRecording ? <FaStop className="icon" /> : <FaMicrophone className='icon' />}
                </Button>
              </div> */}
              {examType === 'THEORY' && <div style={{display:'grid'}}>
                  <div className="text-center align-self-center m-left">
                    <Button variant="dark" style={{padding:'10px 30px',marginBottom:'15px'}} onClick={() => handleClearAns(currentQuestion?.qid)} disabled={isRecording || timer <= 0}>
                      Clear
                    </Button>
                  </div>

                  <div className="text-center align-self-center m-left">
                    {/* <Button variant="outline-danger" onClick={handleMicClick}>
                      {isRecording ? <FaStop className="icon" /> : <FaMicrophone className='icon' />}
                    </Button> */}
                    {isRecording ? <Button variant="outline-success" style={{padding:'10px 40px'}} onClick={handleMicClick} >
                      <FaStop className="icon qes-icon-size"  /> </Button> : <Button variant="outline-danger" style={{padding:'10px 40px'}} onClick={handleMicClick} disabled={timer <= 0}>
                      <FaMicrophone className="icon qes-icon-size" /> </Button> }
                      {isRecording ? <>
                  <div className="text-center mt-3 speak-text">
                  <p style={{color:'green'}}> You are speaking</p>
                </div>
                </>:<>      <div className="text-center mt-3 speak-text">
                  <p style={{color:'red'}}> Click Mic to Speak</p>
                </div></>}
                  </div>

               
                  </div>}
               </Col>
              </Row>
              <div className="text-center mt-3">
                <p style={{ color: timer <= 30 ? 'red' : '' }}>Time Remaining: {timer} seconds</p>
              </div>
              
              <div className="text-center mt-3">
              {showSubmitButton ? (
                    <Button variant="primary" onClick={handleSubmit} disabled={isRecording || isGetAns}>
                      {currentQuestionIndex + 1}/{questions.length} Submit All Answers
                    </Button>
                  ) : (
                    <Button variant="dark" onClick={()=>handleNextQuestion('BUTTON','SUBMIT')} disabled={isRecording || isGetAns}>
                      {currentQuestionIndex + 1}/{questions.length} Next Question {isGetAns && <Spinner ></Spinner>}
                    </Button>
                  )}
              </div>
              {loading && (
                <div className="spinner-overlay">
                  <Spinner animation="border" role="status">
                    <span className="sr-only"></span>
                  </Spinner>
                </div>
              )}
              {respError && <p className='error-msg'>{respError}</p>}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default UsersDemoQuestions;
